import { Splide as f } from "@splidejs/splide";
import { parseSlideDSL as h, compile as m } from "@slidejs/dsl";
import { SlideRunner as g } from "@slidejs/runner";
class u {
  constructor() {
    this.name = "splide", this.eventHandlers = /* @__PURE__ */ new Map();
  }
  /**
   * 初始化 Splide 适配器
   *
   * @param container - 容器元素
   * @param options - Splide 选项
   */
  async initialize(t, i) {
    try {
      if (this.createSplideStructure(t), !this.splideContainer)
        throw new Error("Splide container not created");
      const e = {
        // 默认配置
        type: "slide",
        perPage: 1,
        perMove: 1,
        gap: "1rem",
        pagination: !0,
        arrows: !0,
        keyboard: "global",
        ...i?.splideConfig
      };
      this.splide = new f(this.splideContainer, e), this.splide.mount(), await new Promise((n) => {
        requestAnimationFrame(() => {
          n();
        });
      }), this.setupEventListeners(), this.emit("ready");
    } catch (e) {
      const n = e instanceof Error ? e.message : String(e);
      throw this.emit("error", { message: n }), new Error(`Failed to initialize SplideAdapter: ${n}`);
    }
  }
  /**
   * 渲染幻灯片
   *
   * @param slides - 幻灯片定义数组
   */
  async render(t) {
    if (!this.splideList || !this.splide)
      throw new Error("SplideAdapter not initialized");
    try {
      this.splideList.innerHTML = "";
      for (const i of t) {
        const e = await this.renderSlide(i);
        this.splideList.appendChild(e);
      }
      this.splide.refresh(), this.emit("slideRendered", { totalSlides: t.length });
    } catch (i) {
      const e = i instanceof Error ? i.message : String(i);
      throw this.emit("error", { message: e }), new Error(`Failed to render slides: ${e}`);
    }
  }
  /**
   * 销毁适配器
   */
  async destroy() {
    this.splide && (this.splide.destroy(), this.splide = void 0), this.splideContainer && (this.splideContainer.innerHTML = "", this.splideContainer = void 0), this.splideTrack = void 0, this.splideList = void 0, this.eventHandlers.clear();
  }
  /**
   * 导航到指定幻灯片
   *
   * @param index - 幻灯片索引
   */
  navigateTo(t) {
    if (!this.splide)
      throw new Error("SplideAdapter not initialized");
    this.splide.go(t);
  }
  /**
   * 获取当前幻灯片索引
   */
  getCurrentIndex() {
    return this.splide ? this.splide.index : 0;
  }
  /**
   * 获取幻灯片总数
   */
  getTotalSlides() {
    return this.splide ? this.splide.length : 0;
  }
  /**
   * 更新指定幻灯片
   *
   * @param index - 幻灯片索引
   * @param slide - 新的幻灯片定义
   */
  async updateSlide(t, i) {
    if (!this.splideList || !this.splide)
      throw new Error("SplideAdapter not initialized");
    try {
      const n = this.splideList.querySelectorAll(".splide__slide")[t];
      if (!n)
        throw new Error(`Slide at index ${t} not found`);
      const s = await this.renderSlide(i);
      n.replaceWith(s), this.splide.refresh();
    } catch (e) {
      const n = e instanceof Error ? e.message : String(e);
      throw this.emit("error", { message: n }), new Error(`Failed to update slide: ${n}`);
    }
  }
  /**
   * 注册事件监听器
   *
   * @param event - 事件类型
   * @param handler - 事件处理器
   */
  on(t, i) {
    this.eventHandlers.has(t) || this.eventHandlers.set(t, /* @__PURE__ */ new Set()), this.eventHandlers.get(t).add(i);
  }
  /**
   * 移除事件监听器
   *
   * @param event - 事件类型
   * @param handler - 事件处理器
   */
  off(t, i) {
    const e = this.eventHandlers.get(t);
    e && e.delete(i);
  }
  /**
   * 创建 Splide DOM 结构
   *
   * @param container - 容器元素
   */
  createSplideStructure(t) {
    const i = document.createElement("div");
    i.className = "splide";
    const e = document.createElement("div");
    e.className = "splide__track";
    const n = document.createElement("ul");
    n.className = "splide__list", e.appendChild(n), i.appendChild(e), t.appendChild(i), this.splideContainer = i, this.splideTrack = e, this.splideList = n;
  }
  /**
   * 设置 Splide 事件监听
   */
  setupEventListeners() {
    this.splide && this.splide.on("moved", (t, i) => {
      this.emit("slideChanged", {
        index: t,
        previousIndex: i,
        from: i,
        to: t
      });
    });
  }
  /**
   * 渲染单张幻灯片
   *
   * @param slide - 幻灯片定义
   * @returns slide 元素
   */
  async renderSlide(t) {
    const i = document.createElement("li");
    if (i.className = "splide__slide", t.content.type === "dynamic") {
      const e = await this.renderDynamicContent(t.content.component, t.content.props);
      i.appendChild(e);
    } else {
      const e = this.renderTextContent(t.content.lines);
      i.appendChild(e);
    }
    return i;
  }
  /**
   * 渲染动态内容（Web Component）
   *
   * @param component - 组件名称
   * @param props - 组件属性
   * @returns 组件元素
   */
  async renderDynamicContent(t, i) {
    const e = document.createElement(t);
    for (const [n, s] of Object.entries(i))
      typeof s == "string" || typeof s == "number" ? e.setAttribute(n, String(s)) : typeof s == "boolean" ? s && e.setAttribute(n, "") : e[n] = s;
    return e;
  }
  /**
   * 渲染文本内容
   *
   * 支持以下格式：
   * - # 标题 -> h1
   * - ## 标题 -> h2
   * - ### 标题 -> h3
   * - ![alt](url) -> img
   * - - 列表项 -> ul/li
   * - 普通文本 -> p
   *
   * @param lines - 文本行数组
   * @returns 内容容器元素
   */
  renderTextContent(t) {
    const i = document.createElement("div");
    i.className = "slide-content";
    let e = null;
    for (const n of t) {
      const s = n.trim();
      if (!s) {
        e = null;
        continue;
      }
      if (s.startsWith("# ")) {
        e = null;
        const r = document.createElement("h1");
        r.textContent = s.substring(2), i.appendChild(r);
        continue;
      }
      if (s.startsWith("## ")) {
        e = null;
        const r = document.createElement("h2");
        r.textContent = s.substring(3), i.appendChild(r);
        continue;
      }
      if (s.startsWith("### ")) {
        e = null;
        const r = document.createElement("h3");
        r.textContent = s.substring(4), i.appendChild(r);
        continue;
      }
      const d = s.match(/^!\[(.*?)\]\((.*?)\)$/);
      if (d) {
        e = null;
        const r = document.createElement("img");
        r.alt = d[1], r.src = d[2], r.style.maxWidth = "80%", r.style.maxHeight = "500px", i.appendChild(r);
        continue;
      }
      if (s.startsWith("- ")) {
        e || (e = document.createElement("ul"), i.appendChild(e));
        const r = document.createElement("li");
        r.textContent = s.substring(2), e.appendChild(r);
        continue;
      }
      e = null;
      const l = document.createElement("p");
      l.textContent = s, i.appendChild(l);
    }
    return i;
  }
  /**
   * 触发事件
   *
   * @param event - 事件类型
   * @param data - 事件数据
   */
  emit(t, i) {
    const e = this.eventHandlers.get(t);
    if (e)
      for (const n of e)
        try {
          n(i);
        } catch (s) {
          console.error(`Error in ${t} handler:`, s);
        }
  }
}
const b = ".splide__container{box-sizing:border-box;position:relative}.splide__list{backface-visibility:hidden;display:-ms-flexbox;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{display:none}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{backface-visibility:hidden;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;contain:strict;display:inline-block;height:20px;inset:0;margin:auto;position:absolute;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__arrow{-ms-flex-align:center;align-items:center;background:#ccc;border:0;border-radius:50%;cursor:pointer;display:-ms-flexbox;display:flex;height:2em;-ms-flex-pack:center;justify-content:center;opacity:.7;padding:0;position:absolute;top:50%;transform:translateY(-50%);width:2em;z-index:1}.splide__arrow svg{fill:#000;height:1.2em;width:1.2em}.splide__arrow:hover:not(:disabled){opacity:.9}.splide__arrow:disabled{opacity:.3}.splide__arrow:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide__arrow--prev{left:1em}.splide__arrow--prev svg{transform:scaleX(-1)}.splide__arrow--next{right:1em}.splide.is-focus-in .splide__arrow:focus{outline:3px solid #0bf;outline-offset:3px}.splide__pagination{bottom:.5em;left:0;padding:0 1em;position:absolute;right:0;z-index:1}.splide__pagination__page{background:#ccc;border:0;border-radius:50%;display:inline-block;height:8px;margin:3px;opacity:.7;padding:0;position:relative;transition:transform .2s linear;width:8px}.splide__pagination__page.is-active{background:#fff;transform:scale(1.4);z-index:1}.splide__pagination__page:hover{cursor:pointer;opacity:.9}.splide__pagination__page:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__pagination__page:focus{outline:3px solid #0bf;outline-offset:3px}.splide__progress__bar{background:#ccc;height:3px}.splide__slide{-webkit-tap-highlight-color:rgba(0,0,0,0)}.splide__slide:focus{outline:0}@supports (outline-offset:-3px){.splide__slide:focus-visible{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide__slide:focus-visible{border:3px solid #0bf}}@supports (outline-offset:-3px){.splide.is-focus-in .splide__slide:focus{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide.is-focus-in .splide__slide:focus{border:3px solid #0bf}.splide.is-focus-in .splide__track>.splide__list>.splide__slide:focus{border-color:#0bf}}.splide__toggle{cursor:pointer}.splide__toggle:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__toggle:focus{outline:3px solid #0bf;outline-offset:3px}.splide__track--nav>.splide__list>.splide__slide{border:3px solid transparent;cursor:pointer}.splide__track--nav>.splide__list>.splide__slide.is-active{border:3px solid #000}.splide__arrows--rtl .splide__arrow--prev{left:auto;right:1em}.splide__arrows--rtl .splide__arrow--prev svg{transform:scaleX(1)}.splide__arrows--rtl .splide__arrow--next{left:1em;right:auto}.splide__arrows--rtl .splide__arrow--next svg{transform:scaleX(-1)}.splide__arrows--ttb .splide__arrow{left:50%;transform:translate(-50%)}.splide__arrows--ttb .splide__arrow--prev{top:1em}.splide__arrows--ttb .splide__arrow--prev svg{transform:rotate(-90deg)}.splide__arrows--ttb .splide__arrow--next{bottom:1em;top:auto}.splide__arrows--ttb .splide__arrow--next svg{transform:rotate(90deg)}.splide__pagination--ttb{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;inset:0 .5em 0 auto;padding:1em 0}", x = ".splide{width:100%;height:100%;position:relative;--slidejs-splide-arrow-color: var(--slidejs-arrow-color, #007aff);--slidejs-splide-pagination-color: var(--slidejs-pagination-color, #007aff);--slidejs-splide-pagination-active-color: var(--slidejs-pagination-active-color, #007aff);--slidejs-splide-progress-bar-color: var(--slidejs-progress-bar-color, #007aff)}.splide__track{width:100%;height:100%}.splide__list{width:100%;height:100%;display:flex;flex-direction:row}.splide__slide{display:flex;align-items:center;justify-content:center;width:100%;height:100%;min-height:100%;flex-shrink:0;background:var(--slidejs-background-color, #fff);padding:2rem;box-sizing:border-box}.slide-content{width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center}.slide-content h1{font-size:3rem;margin-bottom:1rem;color:var(--slidejs-heading-color, #333)}.slide-content h2{font-size:2rem;margin-bottom:1rem;color:var(--slidejs-heading-color, #666)}.slide-content h3{font-size:1.5rem;margin-bottom:.5rem;color:var(--slidejs-heading-color, #666)}.slide-content p{font-size:1.2rem;line-height:1.6;color:var(--slidejs-text-color, #555);margin-bottom:1rem}.slide-content ul{text-align:left;display:inline-block;font-size:1.2rem;line-height:1.8;color:var(--slidejs-text-color, #555)}.slide-content li{margin-bottom:.5rem}.slide-content img{border-radius:8px;box-shadow:0 4px 12px #0000001a}.splide__arrow{background-color:var(--slidejs-splide-arrow-color, #007aff)}.splide__pagination{position:absolute;bottom:1rem;left:50%;transform:translate(-50%);z-index:10}.splide__pagination__page{background-color:var(--slidejs-splide-pagination-color, #007aff)}.splide__pagination__page.is-active{background-color:var(--slidejs-splide-pagination-active-color, #007aff)}.splide__progress__bar{background-color:var(--slidejs-splide-progress-bar-color, #007aff)}";
async function C(p, t, i) {
  const e = await h(p), n = m(e), s = "splide-styles";
  if (!document.head.querySelector(`#${s}`)) {
    const o = document.createElement("style");
    o.id = s, o.textContent = b, document.head.appendChild(o);
  }
  let l;
  if (typeof i.container == "string") {
    const o = document.querySelector(i.container);
    if (!o)
      throw new Error(`Container not found: ${i.container}`);
    l = o;
  } else
    l = i.container;
  const r = "slidejs-runner-splide-styles";
  if (!l.querySelector(`#${r}`)) {
    const o = document.createElement("style");
    o.id = r, o.textContent = x, l.appendChild(o);
  }
  const a = document.createElement("div");
  a.style.width = "100%", a.style.height = "100%", l.appendChild(a);
  const _ = new u(), c = new g({
    container: a,
    adapter: _,
    adapterOptions: {
      splideConfig: i.splideOptions
    }
  });
  return await c.run(n, t), c;
}
export {
  u as SplideAdapter,
  C as createSlideRunner
};
//# sourceMappingURL=index.mjs.map
